import type { ReactElement, FC } from 'react';

import { Bold, Container, TimelineRecord } from './styled';

interface ITimelineStep {
    created: string;
    color: string;
    title: string;
    description: string;
    text?: string | undefined;
}

export interface ITimelineProps {
    steps: ITimelineStep[];
}

export const Timeline: FC<ITimelineProps> = ({
    steps,
}: ITimelineProps): ReactElement => {
    return (
        <Container>
            {steps.map((step) => {
                const { color, created, title, description, text } = step;
                return (
                    <TimelineRecord key={created} dotColor={color}>
                        <Bold>{title}</Bold> {text} {description}
                    </TimelineRecord>
                );
            })}
        </Container>
    );
};
